import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-2 mr-2 flex justify-between"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "add", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "swap_vert", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick", "src"]
const _hoisted_9 = {
  key: 1,
  class: "ml-2 mr-2 flex justify-between"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "add", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "content_copy", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "swap_vert", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "delete", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 0,
  class: "ml-2 mr-2 flex justify-between"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "swap_vert", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 1,
  class: "ml-2 mr-2 flex justify-between"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "content_copy", -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "swap_vert", -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "delete", -1)
const _hoisted_35 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_token_picker = _resolveComponent("token-picker")!
  const _component_asset_picker = _resolveComponent("asset-picker")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(`height:${_ctx.canvasParams.canh - 4}px; overflow-y: scroll`)
  }, [
    _createElementVNode("div", null, [
      _createVNode(_component_token_picker, {
        remixes: _ctx.remixes,
        onUpdateRemix: _ctx.updateRemix,
        onRemixSelected: _ctx.remixSelected,
        canvasParams: _ctx.canvasParams,
        remix: _ctx.drawing.remix,
        isRemixType: _ctx.isRemixType,
        canvasOffset: _ctx.canvasOffset
      }, null, 8, ["remixes", "onUpdateRemix", "onRemixSelected", "canvasParams", "remix", "isRemixType", "canvasOffset"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawing.layers, (layer, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (index == _ctx.layerIndex && _ctx.isLayerType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.insertLayer(index))
              }, _hoisted_4, 8, _hoisted_2),
              (index > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.swapLayer(index))
                  }, _hoisted_7, 8, _hoisted_5))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["border-2 border-solid object-fill", `${
          index == _ctx.layerIndex && _ctx.isLayerType
            ? 'border-blue-400'
            : 'border-slate-200'
        }`])
        }, [
          _createElementVNode("img", {
            onClick: ($event: any) => (_ctx.onSelectLayer(index)),
            src: layer.svgImage,
            style: _normalizeStyle(`width:${_ctx.canvasParams.sidew}px;height:${
            _ctx.canvasParams.sidew / 2
          }px`)
          }, null, 12, _hoisted_8)
        ], 2),
        (index == _ctx.layerIndex && _ctx.isLayerType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.insertLayer(index + 1))
              }, _hoisted_12, 8, _hoisted_10),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.copyLayer(index))
              }, _hoisted_15, 8, _hoisted_13),
              (index < _ctx.drawing.layers.length - 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.swapLayer(index + 1))
                  }, _hoisted_18, 8, _hoisted_16))
                : _createCommentVNode("", true),
              (_ctx.drawing.layers.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "ml-2",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteLayer()))
                  }, _hoisted_20))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawing.overlays, (overlay, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (index == _ctx.overlayIndex && _ctx.isOverlayType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (index > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.swapOverlay(index))
                  }, _hoisted_24, 8, _hoisted_22))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["border-2 border-solid object-fill", `${
          index == _ctx.overlayIndex && _ctx.isOverlayType
            ? 'border-blue-400'
            : 'border-slate-200'
        }`]),
          onClick: ($event: any) => (_ctx.onSelectOverlay(index))
        }, [
          _createElementVNode("div", {
            class: "overflow-hidden",
            style: _normalizeStyle(`width:${_ctx.canvasParams.sidew}px;height:${_ctx.canvasParams.sidew}px;`)
          }, [
            _createElementVNode("img", {
              src: overlay.image,
              style: _normalizeStyle(
              `width:${_ctx.canvasParams.sidew}px;height:${_ctx.canvasParams.sidew}px;` +
              `Transform: ${_ctx.overlayTransform(index)}`
            )
            }, null, 12, _hoisted_26)
          ], 4)
        ], 10, _hoisted_25),
        (index == _ctx.overlayIndex && _ctx.isOverlayType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.copyOverlay(index))
              }, _hoisted_30, 8, _hoisted_28),
              (index < _ctx.drawing.overlays.length - 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.swapOverlay(index + 1))
                  }, _hoisted_33, 8, _hoisted_31))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "ml-2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteOverlay()))
              }, _hoisted_35)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("div", null, [
      _createVNode(_component_asset_picker, {
        addresses: _ctx.addresses,
        canvasParams: _ctx.canvasParams,
        canvasOffset: _ctx.canvasOffset,
        onAssetSelected: _ctx.AssetSelected
      }, null, 8, ["addresses", "canvasParams", "canvasOffset", "onAssetSelected"])
    ])
  ], 4))
}